import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'BrowseApiButton' })({
    root: {
        color: '#000',
        background: 'transparent !important',
        border: '1.5px solid #ECECEC'
    },
    _small: {
        padding: '12px 16px',
        fontSize: 15,
        fontWeight: 500,
        lineHeight: '16px',
        borderRadius: 100
    },
    _regular: {
        padding: '20px 40px',
        fontSize: 16,
        fontWeight: 600,
        lineHeight: '16px',
        borderRadius: 80
    }
});
